<div class="d-flex flex-row justify-content-between px-3">
  <h2 mat-dialog-title class="headingBL">
    {{ gettitle(data.title) }}<span> {{ gettitle(data.title, true) }}</span>
  </h2>
  <!-- <div mat-dialog-actions class="btnGlobal--secondary">close</div> -->
  <img mat-dialog-actions (click)="closeDialog()"
    src="https://d2abnqj5vuy2s4.cloudfront.net/assets/images/icons/ic_close.png" alt="close"
    style="width: 2.8rem; height: 2rem" class="point" />
</div>
<div mat-dialog-content class="d-flex flex-column align-items-center gap-2 w-100">
  <!-- <vg-player (onPlayerReady)="onPlayerReady($event)">
    <vg-overlay-play></vg-overlay-play>
    <vg-buffering vgFor="singleVideo"></vg-buffering>
    <vg-scrub-bar>
      <vg-scrub-bar-current-time></vg-scrub-bar-current-time>
      <vg-scrub-bar-buffering-time></vg-scrub-bar-buffering-time>
    </vg-scrub-bar>
    <vg-controls>
      <vg-play-pause></vg-play-pause>
      <vg-playback-button></vg-playback-button>
      <vg-time-display vgProperty="current" vgFormat="mm:ss"></vg-time-display>
      <vg-scrub-bar style="pointer-events: none"></vg-scrub-bar>
      <vg-time-display vgProperty="left" vgFormat="mm:ss"></vg-time-display>
      <vg-time-display vgProperty="total" vgFormat="mm:ss"></vg-time-display>
      <vg-track-selector></vg-track-selector>
      <vg-mute></vg-mute>
      <vg-volume></vg-volume>
      <vg-fullscreen></vg-fullscreen>
    </vg-controls>
    <video
      [vgMedia]="$any(media)"
      #media
      id="singleVideo"
      preload="auto"
      crossorigin
    >
      <source src="https://135vod-adaptive.akamaized.net/exp=1700122412~acl=%2Fd2ccb0d8-21c5-434e-a5ae-fd4581742d66%2F%2A~hmac=196745cfe945bbe41ffd63bd66c427e440bb7bec2a9b1581d938b33e171c6542/d2ccb0d8-21c5-434e-a5ae-fd4581742d66/sep/video/4066314e,92b4b8f7,aed3defe,cec8cfa1,d2d69590/audio/38ceb32e/subtitles/65903326-English%20%28auto-generated%29-en-x-autogen-cc/master.m3u8?external-subs=1&query_string_ranges=1&subcache=1&subtoken=3e51ab3430844c67cf27de71d62b030c6a0463bfcd6241a99fa2dddf47de61bf" type="application/x-mpegURL" />
    </video>
  </vg-player> -->
  <!-- <video #videoPlayer [src]="data.video" autoplay controls></video> -->
  <!-- <video appHlsVideoPlayer controls autoplay >
    <source [src]="data.video" type="application/x-mpegURL">
  </video> -->
  <!-- <vg-player>
    <vg-overlay-play></vg-overlay-play>
    <video #media
      [vgMedia]="media"
      id="singleVideo"
      preload="auto"
      crossorigin
      (vgPlayerReady)="onPlayerReady($event)"
    >
      <source src="YOUR_VIDEO_URL_HERE" type="application/x-mpegURL">
    </video>
  </vg-player> -->
  <iframe *ngIf="data.vimeo" [src]="getSafeVideoUrl()" width="656" height="400" class="web-video"
    frameborder="0" allow="autoplay; fullscreen" allowfullscreen></iframe>

  <iframe *ngIf="data.youtube" [src]="getSafeVideoUrl()" width="100%" height="550" class="web-video" frameborder="0"
    allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
    allowfullscreen></iframe>
  <div *ngIf="!data.vimeo && !data.youtube" class="video-player-container w-100">
    <video #videoPlayer class="videoContainer w-100" [ngClass]="getQualityClass()" controls autoplay [src]="getVideoSource()" playsinline webkit-playsinline preload="auto"></video>

    <!-- Video Quality Overlay Menu -->
    <div class="video-quality-overlay">
      <button
        type="button"
        class="quality-toggle-btn d-flex align-items-center gap-1"
        (click)="toggleQualityMenu($event)"
        title="Select Video Quality"
      >
        <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" fill="currentColor" class="bi bi-gear-fill" viewBox="0 0 16 16">
          <path d="M9.405 1.05c-.413-1.4-2.397-1.4-2.81 0l-.1.34a1.464 1.464 0 0 1-2.105.872l-.31-.17c-1.283-.698-2.686.705-1.987 1.987l.169.311c.446.82.023 1.841-.872 2.105l-.34.1c-1.4.413-1.4 2.397 0 2.81l.34.1a1.464 1.464 0 0 1 .872 2.105l-.17.31c-.698 1.283.705 2.686 1.987 1.987l.311-.169a1.464 1.464 0 0 1 2.105.872l.1.34c.413 1.4 2.397 1.4 2.81 0l.1-.34a1.464 1.464 0 0 1 2.105-.872l.31.17c1.283.698 2.686-.705 1.987-1.987l-.169-.311a1.464 1.464 0 0 1 .872-2.105l.34-.1c1.4-.413 1.4-2.397 0-2.81l-.34-.1a1.464 1.464 0 0 1-.872-2.105l.17-.31c.698-1.283-.705-2.686-1.987-1.987l-.311.169a1.464 1.464 0 0 1-2.105-.872zM8 10.93a2.93 2.93 0 1 1 0-5.86 2.93 2.93 0 0 1 0 5.86"/>
        </svg>
        <span class="quality-label">{{ selectedQuality }}</span>
      </button>

      <div *ngIf="showQualityMenu" class="quality-dropdown-menu">
        <div class="quality-header">Quality</div>
        <button
          *ngFor="let q of availableQualities"
          type="button"
          class="quality-option-btn d-flex align-items-center justify-content-between"
          [class.active]="selectedQuality === q"
          (click)="changeQuality(q)"
        >
          <span>{{ q }}</span>
          <svg *ngIf="selectedQuality === q" xmlns="http://www.w3.org/2000/svg" width="14" height="14" fill="currentColor" class="bi bi-check2" viewBox="0 0 16 16">
            <path d="M13.854 3.646a.5.5 0 0 1 0 .708l-7 7a.5.5 0 0 1-.708 0l-3.5-3.5a.5.5 0 1 1 .708-.708L6.5 10.293l6.646-6.647a.5.5 0 0 1 .708 0"/>
          </svg>
        </button>
      </div>
    </div>
  </div>

  <div *ngIf="!data.vimeo && !data.youtube" class="d-flex align-items-center justify-content-center gap-3 my-2">
    <button type="button" class="btn btn-sm btn-outline-secondary d-inline-flex align-items-center"
      (click)="skipBackward(10)">
      <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" fill="currentColor"
        class="bi bi-arrow-counterclockwise me-1" viewBox="0 0 16 16">
        <path fill-rule="evenodd" d="M8 3a5 5 0 1 1-4.546 2.914.5.5 0 0 0-.908-.417A6 6 0 1 0 8 2z" />
        <path d="M8 1.05a.5.5 0 0 0-.5.5v3a.5.5 0 0 0 .854.354l1.5-1.5a.5.5 0 0 0 0-.708l-1.5-1.5A.5.5 0 0 0 8 1.05" />
      </svg>
      Backward 10s
    </button>
    <button type="button" class="btn btn-sm btn-outline-secondary d-inline-flex align-items-center"
      (click)="skipForward(10)">
      Forward 10s
      <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" fill="currentColor"
        class="bi bi-arrow-clockwise ms-1" viewBox="0 0 16 16">
        <path fill-rule="evenodd" d="M8 3a5 5 0 1 0 4.546 2.914.5.5 0 0 1 .908-.417A6 6 0 1 1 8 2z" />
        <path d="M8 1.05a.5.5 0 0 1 .5.5v3a.5.5 0 0 1-.854.354l-1.5-1.5a.5.5 0 0 1 0-.708l1.5-1.5A.5.5 0 0 1 8 1.05" />
      </svg>
    </button>
  </div>
  <!-- <video *ngIf="!data.vimeo" class="w-75" controls>
    <source [src]="data.video" />
  </video> -->
  <!-- <div class="w-100"  [attr.data-vimeo-url]="data.video" *ngIf="!data.vimeo" id="vimeoPlayer"></div> -->
  <div class="vtext1" *ngIf="data.discription !== ''">
    {{ data.discription }}
  </div>
</div>

<!-- https://135vod-adaptive.akamaized.net/exp=1700122412~acl=%2Fd2ccb0d8-21c5-434e-a5ae-fd4581742d66%2F%2A~hmac=196745cfe945bbe41ffd63bd66c427e440bb7bec2a9b1581d938b33e171c6542/d2ccb0d8-21c5-434e-a5ae-fd4581742d66/sep/video/4066314e,92b4b8f7,aed3defe,cec8cfa1,d2d69590/audio/38ceb32e/subtitles/65903326-English%20%28auto-generated%29-en-x-autogen-cc/master.m3u8?external-subs=1&query_string_ranges=1&subcache=1&subtoken=3e51ab3430844c67cf27de71d62b030c6a0463bfcd6241a99fa2dddf47de61bf -->